export default {
  props: {
    zIndex: {
      type: Number,
      default: 10000
    },
    maskClosable: {
      type: Boolean,
      default: false
    }
  }
}
